import { useTranslation } from "react-i18next";
import ServiceList from "./ServiceList/ServiceList";

const Services = () => {
  const { t } = useTranslation();


  return (
      <div className="service-area pt--120 bg_color--1" id="service">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center service-style--3 mb--30">
                <h2 className="title">{t("services.title")}</h2>
                <p>{t("services.description")}</p>
              </div>
            </div>
          </div>
          <ServiceList />
        </div>
      </div>
  );
}

export default Services;
